import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared.module';
import { AdminPage } from './admin.page';
import { MarkdownModule } from 'ngx-markdown';
import { AiChatModule } from 'src/app/component/ai-chat/ai-chat.module';

const routes: Routes = [
  {
    path: '',
    component: AdminPage,
    children: [
      {
        path: 'products',
        loadChildren: () => import('./admin-product/admin-product.module').then((m) => m.AdminProductPageModule),
      },
      // ... (other child routes)
    ],
  },
];

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes), MarkdownModule.forRoot(), AiChatModule],
  declarations: [AdminPage],
  exports: [AdminPage],
})
export class AdminPageModule {}
